import React from 'react';

interface AccessDeniedProps {
  message?: string;
}

/**
 * Standard "access denied" panel shown when a user lacks the capability
 * required to view a page. Pair with <WithCapability fallback={<AccessDenied />}>.
 */
export const AccessDenied: React.FC<AccessDeniedProps> = ({
  message = 'You do not have permission to view this page.',
}) => (
  <div className="flex items-center justify-center h-64">
    <div className="text-center">
      <h2 className="text-2xl font-bold text-foreground mb-2">Access Denied</h2>
      <p className="text-muted-foreground">{message}</p>
    </div>
  </div>
);
